import { useMemo } from 'react';

export const useContentHeight = (): string => {
  return useMemo(() => {
    const headerRows = document.getElementsByClassName('header-rows')[0];

    return `calc(100vh - env(safe-area-inset-bottom) - ${
      headerRows ? headerRows.getBoundingClientRect().height : 0
    }px`;
  }, []);
};
